
import Layout from "@/components/Layout";
import UserListingsContainer from "@/components/user-listings/UserListingsContainer";

const UserListingsPage = () => {
  return (
    <Layout>
      <UserListingsContainer />
    </Layout>
  );
};

export default UserListingsPage;
